// extracted by mini-css-extract-plugin
module.exports = {"external":"ExternalLinkModal_external__YeOmn","closeIcon":"ExternalLinkModal_closeIcon__jlYvv","buttonBlock":"ExternalLinkModal_buttonBlock__OQRGH"};